import { Expose } from 'class-transformer';

export class ResponseBase {
  success: boolean = true;
  message?: string;
  errorCode?: number;
  header?: string;
}
